import { render, staticRenderFns } from "./ExhibitionMade.vue?vue&type=template&id=59136c56&"
import script from "./ExhibitionMade.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMade.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionMade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports